module.exports = __webpack_public_path__ + "img/snout.38ea4fe7.svg";